// extracted by mini-css-extract-plugin
export default {"pageSizePickerLabel":"PageSizePicker_pageSizePickerLabel__pucq4","pageSizePicker":"PageSizePicker_pageSizePicker__LfVY1"};